<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button [disabled]="loading == true || isProcessing == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">
							Refresh
						</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button [disabled]="loading == true || isProcessing == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPrint()">
							Print Schedule
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstSectionScheduleStudent"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedSectionScheduleStudent"
						dataKey="SectionScheduleDetailID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--Semester-->
								<th>
									<p-columnFilter id="SemesterFilter" field="Semester" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterSemester
												[ngModel]="value"
												[options]="lstSemester"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--DayDesc-->
								<th>
									<p-columnFilter id="DayFilter" field="DayDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterDayDesc
												[ngModel]="value"
												[options]="lstDayDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!-- PeriodNo -->
								<th class="SmallCol">
									<p-columnFilter id="PeriodNoFilter" field="PeriodNo" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterPeriodNo
												[ngModel]="value"
												[options]="lstPeriodNo"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--PeriodDesc-->
								<th>
									<p-columnFilter id="PeriodFilter" field="PeriodDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterPeriodDesc
												[ngModel]="value"
												[options]="lstPeriodDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--PeriodTimeDesc-->
								<th></th>

								<!--CourseDesc-->
								<th>
									<p-columnFilter id="CourseFilter" type="text" field="CourseDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--CourseTypeDesc-->
								<th>
									<p-columnFilter id="CourseTypeFilter" field="CourseTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterCourseTypeDesc
												[ngModel]="value"
												[options]="lstCourseTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--SectionNo-->
								<th class="SmallCol">
									<p-columnFilter id="SectionNoFilter" field="SectionNo" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterSectionNo
												[ngModel]="value"
												[options]="lstSectionNo"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--TeacherName-->
								<th>
									<p-columnFilter
										id="TeacherNameFilter"
										type="text"
										field="TeacherName"
										matchMode="contains"
										[showMenu]="true"
									></p-columnFilter>
								</th>

								<!--RoomNo-->
								<th>
									<p-columnFilter id="RoomNoFilter" field="RoomNo" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterRoomNo
												[ngModel]="value"
												[options]="lstRoomNo"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="Semester">Semester<p-sortIcon field="Semester"></p-sortIcon></th>
								<th pSortableColumn="DayDesc">Day<p-sortIcon field="DayDesc"></p-sortIcon></th>
								<th pSortableColumn="PeriodNo" class="SmallCol">Period Number<p-sortIcon field="PeriodNo"></p-sortIcon></th>
								<th pSortableColumn="PeriodDesc">Period Description<p-sortIcon field="PeriodDesc"></p-sortIcon></th>
								<th pSortableColumn="StartTime">Period Time<p-sortIcon field="StartTime"></p-sortIcon></th>
								<th pSortableColumn="CourseDesc">Course<p-sortIcon field="CourseDesc"></p-sortIcon></th>
								<th pSortableColumn="CourseTypeDesc">Course Type<p-sortIcon field="CourseTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="SectionNo" class="SmallCol">Section No<p-sortIcon field="SectionNo"></p-sortIcon></th>
								<th pSortableColumn="TeacherName">Teacher<p-sortIcon field="TeacherName"></p-sortIcon></th>
								<th pSortableColumn="RoomNo">Room No<p-sortIcon field="RoomNo"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-SectionScheduleStudent>
							<tr [pSelectableRow]="SectionScheduleStudent">
								<td class="TableCell">
									{{ SectionScheduleStudent.Semester }}
								</td>

								<td class="TableCell">
									{{ SectionScheduleStudent.DayDesc }}
								</td>

								<td class="TableCell SmallCol">
									{{ SectionScheduleStudent.PeriodNo }}
								</td>

								<td class="TableCell">
									{{ SectionScheduleStudent.PeriodDesc }}
								</td>

								<td class="TableCell">
									{{ SectionScheduleStudent.PeriodTimeDesc }}
								</td>

								<td class="TableCell">
									{{ SectionScheduleStudent.CourseDesc }}
								</td>

								<td class="TableCell">
									{{ SectionScheduleStudent.CourseTypeDesc }}
								</td>

								<td class="TableCell SmallCol">
									{{ SectionScheduleStudent.SectionNo }}
								</td>

								<td class="TableCell">
									{{ SectionScheduleStudent.TeacherName }}
								</td>

								<td class="TableCell">
									{{ SectionScheduleStudent.RoomNo }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div class="TopMargin">
					<div name="isProcessing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>
			</div>
		</div>
	</div>
</div>
